import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { CookiesAgreementComponent } from './cookies-agreement.component';

@NgModule({
  declarations: [CookiesAgreementComponent],
  exports: [CookiesAgreementComponent],
  imports: [CommonModule, SdvorButtonComponent],
})
export class CookiesAgreementComponentModule {}
